module.exports = "<div class=\"meter text-center\">\r\n    <span id=\"file-{{params.rowIndex}}\" class=\"progress\" style=\"width: 0%\"></span>\r\n  </div>\r\n<span class=\"text\">{{params.data.progress}}%</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/progressbar/progressbar.component.html
// module id = ./src/app/progressbar/progressbar.component.html
// module chunks = main